module.exports = __webpack_public_path__ + "static/media/wizualizacja-102.bfc7f6b2.png";